import { createTheme } from "@mui/material/styles";
import { themeBreakpoints } from "./themeBreakpoints.module";
import { typography } from "./typography.module";
import { resolve, stripUnitFromObject, tokenBreakpoints } from "./utils";
const defaultTheme = createTheme();
export const breakpointsUp = defaultTheme.breakpoints.up;
export const textFieldLabelResponsive = (dt, variant2) => {
    const style = [];
    const breakpoints = stripUnitFromObject(dt.layout.media);
    const input = dt.inputField.media;
    for (const i in themeBreakpoints(breakpoints).keys) {
        if (input[tokenBreakpoints[i]]) {
            style[breakpointsUp(themeBreakpoints(breakpoints).values[themeBreakpoints(breakpoints).keys[i]])] =
                typography(resolve(input[tokenBreakpoints[i]], variant2), dt.fontFamilies.body.fallback);
        }
    }
    return style;
};
